import UsersActionsTable from './UsersActionsTable';

export default UsersActionsTable;
